import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import Faq from "../components/Faq";
import Grid from "../components/Grid";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { isMobile } from "react-device-detect";

const Frequently = ({title}) => {
    document.querySelector('title').innerHTML = title

    const navigate = useNavigate()

    return (
        <div className="frequently-asked-questions-page">
            <Header />
            <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div id="faq">
                        <Spacebox padding="20px" />
                        <Container>
                            <Typography variant="h4" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px' }}>
                                Frequently Asked Questions
                            </Typography>
                            <Spacebox padding="10px" />
                            <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                Everything you need to know about business funding with BrightStarr. Can't find what <br />you're looking for? Contact our support team.
                            </Typography>
                            <Spacebox padding="20px" />
                            <Faq />
                        </Container>
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>
            <section>
                <Flexbox alignItems="center" justifyContent="center">
                    <div>
                        <Spacebox padding="20px" />
                        <Container>
                            <div style={{ border: '1px solid #4A3FFF20', borderRadius: '10px', padding: isMobile ? '15px' : '30px' }}>
                                <Spacebox className="hide-on-mid-and-small" padding="20px" />
                                <Flexbox alignItems="center" justifyContent="center">
                                    <div>
                                        <Flexbox alignItems="center" justifyContent="center">
                                            <img src="/svgs/star.svg" alt="star" style={{ width: '20px' }} />
                                        </Flexbox>
                                        <Spacebox padding="10px" />
                                        <Typography variant="h4" style={{ textAlign: 'center', fontSize: '30px' }}>
                                            Ready to Grow Your Business?
                                        </Typography>
                                        <Spacebox padding="10px" />
                                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                                            Book your free consultation today and discover how much funding you <br />qualify for.
                                        </Typography>
                                        <Spacebox padding="20px" />
                                        <Grid grid={isMobile ? 1 : 2} gap="20px">
                                            <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '20px 50px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                                <Flexbox alignItems="center">
                                                    <b style={{ fontSize: '20px' }}>Book Free Consultation</b>
                                                    <Spacebox padding="10px" />
                                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                                </Flexbox>
                                            </Button>
                                            <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '20px 50px', backgroundColor: 'transparent', border: '1px solid #00000020', color: 'black', width: 'fit-content' }} handleClick={() => { }}>
                                                <Flexbox alignItems="center">
                                                    <b style={{ fontSize: '20px' }}>Learn More</b>
                                                    <Spacebox padding="10px" />
                                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px' }} />
                                                </Flexbox>
                                            </Button>
                                            <Button className="hide-on-large-only" style={{ borderRadius: '5px', padding: '20px 0px', backgroundColor: 'var(--primary)', color: 'white', width: '100%' }} handleClick={() => navigate('/book')}>
                                                <b style={{ fontSize: '20px' }}>Book Free Consultation</b>
                                            </Button>
                                        </Grid>
                                    </div>
                                </Flexbox>
                                <Spacebox className="hide-on-mid-and-small" padding="20px" />
                            </div>
                        </Container>
                        <Spacebox padding="20px" />
                    </div>
                </Flexbox>
            </section>
            <Footer />
        </div>
    );
}

export default Frequently;